/**
 * <ActivityOverlays> — la fiche d'une activité, et la SEULE fente d'accusé de l'écran.
 *
 * La fiche n'appartient à aucun des trois écrans d'activités : la liste, les archivées et les
 * réalisations l'ouvrent toutes les trois. Elle est donc montée une fois, ici, et les écrans
 * reçoivent l'ouvreur en props. « Générer une activité », lui, ne se monte qu'à l'ouverture
 * (`<GenerateActivityOverlay>`) : il installe une trentaine de crochets.
 *
 * Deux gestes produisent un accusé — celui de la fiche (« Redonner ») et celui de l'écran
 * (archiver, restaurer) — et deux `<Snackbar>` empilés s'écrivaient l'un sur l'autre. Il n'y en a
 * plus qu'un : celui de la fiche gagne tant qu'il est à l'écran, parce que la fiche est modale au
 * moment où elle produit le sien — il est donc toujours le plus récent des deux.
 */
import React from "react"

import { ActivityDetailsModal, Snackbar } from "../../../../../../design-system"
import { type SnackbarProps } from "../../../../../../design-system/molecules/Snackbar"
import { type UseActivityDetailsFlowResult } from "../../../hooks/useActivityDetailsFlow"

export type ActivityOverlaysProps = {
    details: UseActivityDetailsFlowResult["details"]
    /** L'accusé de la fiche. */
    notice: UseActivityDetailsFlowResult["notice"]
    /** L'accusé de l'écran, quand il en produit un. */
    screenNotice?: SnackbarProps | null
}

export function ActivityOverlays(props: ActivityOverlaysProps) {
    const { details, notice, screenNotice } = props

    return (
        <>
            <ActivityDetailsModal {...details} />
            <Snackbar {...(notice.visible || screenNotice == null ? notice : screenNotice)} />
        </>
    )
}
